import axios from "axios";

const BASE_URL = "https://api.lubrichem.co.in";

const makeRequest = axios.create({
  baseURL: BASE_URL,
  headers: {
    accept: "*/*",
    "Content-Type": "application/json",
  },
});

export default makeRequest;
